import { 
    Button, 
    Stack, 
    Typography 
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Translations } from "../localization/translations";
import WebAssetOffIcon from "@mui/icons-material/WebAssetOff";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";

const NotFoundBlock: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    
    return (
        <Stack
            spacing={2}
            justifyContent="center"
            alignItems="center"
            flex={1}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                spacing={2}
            >
                <Typography variant="h1" color="primary">
                    404
                </Typography>
                <WebAssetOffIcon color="primary" sx={{ fontSize: 100 }} />
            </Stack>
            <Typography
                color="primary"
                variant="h6"
                sx={{ textTransform: "uppercase" }}
            >
                {t<string>(Translations.pageNotFound.text.heading)}
            </Typography>
            <Stack alignItems="center">
                <Typography>
                    {t<string>(Translations.pageNotFound.text.caption1)}
                </Typography>
                <Typography>
                    {t<string>(Translations.pageNotFound.text.caption2)}
                </Typography>
            </Stack>
            <Button
                variant="contained"
                startIcon={<KeyboardBackspaceIcon />}
                onClick={() => navigate(-1)}
            >
                {t<string>(Translations.pageNotFound.button.back)}
            </Button>
        </Stack>
    )
}

export default NotFoundBlock;